import { createContext } from 'react'

export type OneOnOnesContextState = {
  canSeeMeetings: boolean
  canSeeAdvancedMeetings: boolean
  isBecome: boolean
  loading: boolean
}

export const OneOnOnesContext = createContext<OneOnOnesContextState | undefined>(undefined)
